module.exports = __webpack_public_path__ + "static/media/lend_tusd.391aca69.svg";